import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import _ from "lodash";
import { Card, WingBlank, WhiteSpace } from "antd-mobile";
import { Row, Col, Button, Skeleton, message, Spin, Input, Icon } from "antd";
import "antd/dist/antd.css";
import "antd-mobile/dist/antd-mobile.css";
import moment from "moment";
import fire from "./fire";
import InfiniteScroll from "react-infinite-scroller";
import { handleUpdateDisable, labelTranslator } from "./helper/helper";
const statStyle = {
  marginLeft: 15,
  color: "#000000",
  fontSize: 24,
};
const cardStyle = {
  display: "flex",
  justifyContent: "flex-end",
  fontSize: 14,
};
const containerStyle = {
  display: "flex",
  justifyContent: "center",
  width: "100%",
  maxWidth: 750,
  background: "rgb(0 0 0 / 2%)",
  marginBottom: 25,
  marginTop: 25,
  boxShadow: "5px 9px 11px 0px rgba(0,0,0,0.64)",
};

const Dashboard = (props) => {
  const [advises, setAdvises] = useState([]);
  const [adviseStats, setAdviseStats] = useState({});
  const [filter, setFilter] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [hasMoreAdvises, setHasMoreAdvises] = useState(true);
  const [adviseItems, setAdviseItems] = useState([]);
  const [adviseIsLoading, setAdviceIsLoading] = useState(false);
  const [userRole, setUserRole] = useState();
  const [showSearchInput, setSearchInput] = useState();
  // const [id, setId] = useState();
  const db = fire.firestore();
  //checks if user is loggedin on pageload
  //fetches advisory data on page load
  useEffect(() => {
    getQuerySnapshot();
    checkLogin();
    // disableAdviseUpdate();
  }, []);

  //function to check if the user's logged in
  const checkLogin = async () => {
    fire.auth().onAuthStateChanged(async function (user) {
      if (user) {
        // User is signed in.
        // setId(user.uid)
      } else {
        // No user is signed in.
        props.history.push("/phone-login");
      }
    });
  };
  //routing to update advise page
  const goToUpdateAdvise = (advise) => {
    props.history.push({
      pathname: "/update-advise",
      state: { detail: advise, role: userRole },
    });
  };
  //routing to add advise page
  const goToAddAdvice = () => {
    const id = fire.auth().currentUser.uid;
    props.history.push({
      pathname: "/add-advise",
      state: { uid: id },
    });
  };
  //function to log out user
  const handleLogout = () => {
    fire
      .auth()
      .signOut()
      .then(function () {
        props.history.push("/phone-login");
        window.location.reload();
      })
      .catch(function (error) {
        // An error happened.
      });
  };
  const getQuerySnapshot = async () => {
    const tempAdvises = [];
    let finalAdviseData = {};
    const querySnapshot = await db
      .collection("advises")
      .orderBy("createdAt", "desc")
      .get();
    const id = await fire.auth().currentUser.uid;
    querySnapshot.forEach((doc) => {
      // filter with id
      if (doc.data()["createdBy"]["uid"] === id) {
        finalAdviseData = doc.data();
        var adviseId = "adviseId";
        finalAdviseData[adviseId] = doc.id;
        tempAdvises.push(finalAdviseData);
      }
    });
    setIsLoading(false);
    setAdvises(tempAdvises);
    if (tempAdvises.length == 0) {
      setHasMoreAdvises(false);
      message.warning("No Advises Created!!");
    }
    const userSnapshot = await db.collection("users").doc(id).get();
    let userData = await userSnapshot.data();
    setUserRole("advisor");
    const statsSnapshotRef = await db
      .collection("global")
      .doc("advisoryStats")
      .collection("advisorStats")
      .doc(id);
    const statsSnapshot = await statsSnapshotRef.get();
    if (statsSnapshot.exists) {
      setAdviseStats(statsSnapshot.data());
    } else {
      const newStatsDoc = {
        name: userSnapshot.data().name,
        profileImageUrl: userSnapshot.data().profileImage,
        activatedAdvises: 0,
        advisorId: userSnapshot.data().advisorId,
        denominator: 0,
        targetHit: 0,
        totalAdvises: 0,
      };
      statsSnapshotRef.set(newStatsDoc);
    }
    setIsLoading(false);
  };
  const handleInfiniteOnLoad = () => {
    if (advises.length !== 0) {
      // loads only when there are active advises
      let data = adviseItems;
      setAdviceIsLoading(true);
      if (filter.type === "search") {
        setHasMoreAdvises(false);
        setAdviceIsLoading(false);
      } else {
        if (data.length >= advises.length) {
          message.success("All Advises Loaded");
          setHasMoreAdvises(false);
          setAdviceIsLoading(false);
          return;
        }
        let size = data.length;
        data = advises.slice(0, size + 3);
        setAdviseItems(data);
        setAdviceIsLoading(false);
      }
    }
  };
  //components
  // returns position type with styling
  const positionTypeIndicator = (position) => {
    let color = "";
    position == "BUY" ? (color = "#07ad61") : (color = "#eb0f29");
    return (
      <>
        <div
          style={{
            height: 7,
            width: 7,
            borderRadius: "50%",
            backgroundColor: `${color}`,
            marginRight: 5,
          }}
        />
        {position}
      </>
    );
  };
  const commentsAdviseStatusIndicator = (status) => {
    let color = "";
    switch (status) {
      case "Waiting For Activation":
        color = "#ffc800";
        break;
      case "Activated":
        color = "#00bf69";
        break;
      case "Target Hit":
        color = "#00875a";
        break;
      case "Manual Exit":
        color = "#ff8b00";
        break;
      case "Manual Avoid":
        color = "#5243aa";
        break;
      case "Expired":
        color = "#ffc800";
        break;
      case "Stop Loss Hit":
        color = "#de350b";
        break;
      default:
        break;
    }
    return (
      <>
        <div
          style={{
            height: 7,
            width: 7,
            borderRadius: "50%",
            backgroundColor: `${color}`,
            marginTop: 3,
            marginRight: 3,
            display: "inline-block",
          }}
        />
        {status}
      </>
    );
  };
  const adviseStatusIndicator = (status) => {
    let color = "";
    switch (status) {
      case "Waiting For Activation":
        color = "#ffc800";
        break;
      case "Activated":
        color = "#00bf69";
        break;
      case "Target Hit":
        color = "#00875a";
        break;
      case "Manual Exit":
        color = "#ff8b00";
        break;
      case "Manual Avoid":
        color = "#5243aa";
        break;
      case "Expired":
        color = "#ffc800";
        break;
      case "Stop Loss Hit":
        color = "#de350b";
        break;
      default:
        break;
    }
    return (
      <span
        style={{
          backgroundColor: `${color}`,
          fontSize: 9,
          color: "white",
          padding: 5,
          borderRadius: 5,
        }}
      >
        {status}
      </span>
    );
  };
  const symbolCheck = (symbol) => {
    // const call = "CE";
    // const put = "PE";
    // let symbolEnding = symbol.substring(symbol.length - 2, symbol.length);
    // return symbolEnding === call || symbolEnding === put ? true : false;
    return symbol.includes("2") ? true : false;
    // return advise.symbol.includes('CE')||advise.symbol.includes('PE')
  };
  const formatAdvisorySymbol = (symbol) => {
    const month = {
      "01": "JAN",
      "02": "FEB",
      "03": "MAR",
      "04": "APR",
      "05": "MAY",
      "06": "JUN",
      "07": "JUL",
      "08": "AUG",
      "09": "SEP",
      10: "OCT",
      11: "NOV",
      12: "DEC",
    };

    let result = "";
    let i = 0;
    let flag = false;
    if (symbol.toUpperCase().includes("FUT")) {
      for (; i < symbol.length; i++) {
        if (symbol[i] == "2") break;
        else result += symbol[i];
      }
      result += `${symbol[i++]}${symbol[i++]} ${symbol[i++]}${symbol[i++]}${
        symbol[i++]
      } FUT`;
    } else {
      for (; i < symbol.length - 2 && !flag; i++) {
        if (symbol[i] === "2") {
          flag = true;
        } else {
          result += symbol[i];
        }
      }
      if (flag) {
        --i;
        ++i;
        result += ` ${month[symbol[++i] + symbol[++i]]} ${symbol[++i]}${
          symbol[++i]
        } `;
        i++;
        while (symbol[i] !== "C" && symbol[i] !== "P") {
          result += symbol[i];
          i++;
        }
        if (symbol[i] === "C") result += "CE";
        else result += "PE";
      }
    }
    return result;
  };
  const AdvisorySuccessRate = (props) => {
    const successRate = ((props.targetHit / props.denominator) * 100).toFixed(
      2
    );
    return <div>{successRate}%</div>;
  };
  // returns cards with advise data
  // contains filter logic
  // need to simplify code
  const handleSearch = (e) => {
    let searchKey = e.target.value;
    setAdviseItems(
      advises.filter((advise, index) =>
        advise.symbol.toLowerCase().includes(searchKey.toLowerCase())
      )
    );
    setFilter({ type: "search", searchKey: searchKey });
  };

  const debouncedSearch = _.debounce(handleSearch, 1500);

  const adviseList = (props) =>
    isLoading ? ( // screen is loading
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          background: "rgba(255,255,255)",
          margin: 15,
          padding: 10,
          border: "2px black",
        }}
      >
        <Skeleton count={3} width="80%" />
      </div>
    ) : adviseItems ? ( // advises not empty
      adviseItems
        .filter((advise) => {
          if (props == "inactive") {
            return !(
              advise.status == "Waiting For Activation" ||
              advise.status == "Activated"
            );
          } else if (props == "active") {
            return (
              advise.status == "Waiting For Activation" ||
              advise.status == "Activated"
            );
          } else if (props?.type === "search") {
            return advise.symbol
              .toLowerCase()
              .includes(props.searchKey.toLowerCase());
          } else {
            return advise;
          }
        })
        .map((advise, index) => (
          <WingBlank key={index} size="lg">
            <WhiteSpace size="lg" />
            <Card
              style={{ boxShadow: "4px 4px 6px 0px rgba(50, 50, 50, 0.3)" }}
            >
              <Card.Header
                title={
                  <div style={{ fontSize: 15, fontWeight: 700 }}>
                    {symbolCheck(advise.symbol)
                      ? formatAdvisorySymbol(advise.symbol)
                      : advise.symbol}
                  </div>
                }
                extra={
                  <div style={{ marginTop: -5 }}>
                    {adviseStatusIndicator(advise.status)}
                  </div>
                }
              />
              <Card.Header
                style={{ marginTop: "-15px", fontSize: 12 }}
                extra={
                  <div style={{ fontSize: 12 }}>
                    {moment(advise.updatedAt).format("DD MMM h:mm")}
                  </div>
                }
                title={positionTypeIndicator(advise.positionType)}
              />
              <Card.Body>
                {advise?.quickTradeType ? (
                  <Row>
                    <Col span={12}>
                      <div>Trade Type</div>
                    </Col>
                    <Col span={12}>
                      <div style={cardStyle}>
                        {labelTranslator(advise.quickTradeType)}
                      </div>
                    </Col>
                  </Row>
                ) : null}
                {advise.quickTradeType === "options" ||
                advise.quickTradeType === "futures" ? (
                  <Row>
                    <Col span={12}>
                      <div>Expiry</div>
                    </Col>
                    <Col span={12}>
                      <div style={cardStyle}>
                        {labelTranslator(advise.expiry)}
                      </div>
                    </Col>
                  </Row>
                ) : null}
                <Row>
                  <Col span={12}>
                    <div>Entry Price</div>
                  </Col>
                  <Col span={12}>
                    <div style={cardStyle}>
                      {advise.entryPriceFrom}-{advise.entryPriceTo}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <div>Target Price</div>
                  </Col>
                  <Col span={12}>
                    <div style={cardStyle}>
                      {advise.targetPriceFrom}-{advise.targetPriceTo}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <div>Stop Loss</div>
                  </Col>
                  <Col span={12}>
                    <div style={cardStyle}>{advise.slPrice}</div>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <div>Duration</div>
                  </Col>
                  <Col span={12}>
                    <div style={cardStyle}>{advise.advisoryType}</div>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <div>Valid Till</div>
                  </Col>
                  <Col span={12}>
                    <div style={cardStyle}>
                      {moment(advise.validTill).format("DD MMM YY, h:mm A")}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer
                content={
                  <Button
                    style={{ width: "100%", marginBottom: 20 }}
                    type="primary"
                    disabled={handleUpdateDisable(userRole, advise.status)}
                    onClick={() => goToUpdateAdvise(advise)}
                  >
                    Update
                  </Button>
                }
              />
              <Card.Body>
                {/* <div style={{display: "flex",justifyContent:"left"}}>{positionTypeIndicator(advise.comments[advise.comments.length - 1].status)}</div> */}
                <div>
                  {false ? (
                    <div>
                      <span style={{ fontWeight: 700 }}>
                        {advise.comments[advise.comments.length - 1].status}
                      </span>
                      <br />
                      {advise.comments[advise.comments.length - 1].message}
                      <span>View Details</span>
                    </div>
                  ) : (
                    <div style={{ maxHeight: 100, overflowY: "scroll" }}>
                      {advise.comments
                        .slice()
                        .reverse()
                        .map((item) => (
                          <>
                            <span style={{ fontWeight: 600, fontSize: 14 }}>
                              {commentsAdviseStatusIndicator(item.status)}
                            </span>
                            <br />
                            <span style={{ fontSize: 13 }}>{item.message}</span>
                            <br />
                          </>
                        ))}
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
            <WhiteSpace size="lg" />
          </WingBlank>
        ))
    ) : (
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          background: "rgba(255,255,255)",
          margin: 15,
          padding: 10,
          borderRadius: 5,
          boxShadow: "4px 4px 6px 0px rgba(50, 50, 50, 0.3)",
        }}
      >
        <Card full>
          <Card.Header title="No Advises Found"></Card.Header>
        </Card>
      </div>
    );

  return (
    // <div className="containerStyle" style={{ display: "flex", justifyContent: "center" }}>
    <div>
      <section className="adviseContainer">
        <nav>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: 15,
            }}
          >
            <Button type="primary" onClick={goToAddAdvice}>
              Add Advise<i style={{ marginLeft: 5 }} className="fa fa-plus"></i>
            </Button>
            <Button type="primary" onClick={handleLogout}>
              Logout
            </Button>
          </div>
        </nav>
        <Row className="advisoryStatsContainer">
          <Col span={8}>
            <div className="statTitleContainer">
              <span
                style={{ backgroundColor: "#ffc400" }}
                className="advisoryStatsSpan"
              ></span>
              <div className="advisoryStatTitle">Total Advises</div>
            </div>
            <div style={statStyle}>{adviseStats.totalAdvises}</div>
          </Col>
          <Col span={8}>
            <div className="statTitleContainer">
              <span
                style={{ backgroundColor: "#5ad5fd" }}
                className="advisoryStatsSpan"
              ></span>
              <div className="advisoryStatTitle">Activated Advises</div>
            </div>
            <div style={statStyle}>{adviseStats.activatedAdvises}</div>
          </Col>
          <Col span={8}>
            <div className="statTitleContainer">
              <span
                style={{ backgroundColor: "#07ad61" }}
                className="advisoryStatsSpan"
              ></span>
              <div className="advisoryStatTitle">Success Rate</div>
            </div>
            <div style={statStyle}>
              {!(adviseStats.targetHit / adviseStats.denominator) ? (
                ""
              ) : (
                <AdvisorySuccessRate
                  targetHit={adviseStats.targetHit}
                  denominator={adviseStats.denominator}
                />
              )}
            </div>
          </Col>
        </Row>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            background: "rgba(255,255,255)",
            margin: 15,
            padding: 10,
            border: "2px black",
            borderRadius: 5,
            boxShadow: "4px 4px 6px 0px rgba(50, 50, 50, 0.3)",
          }}
        >
          <Button
            type="secondary"
            shape="round"
            onClick={() => {
              setIsLoading(true);
              getQuerySnapshot();
            }}
          >
            <Icon
              type="sync"
              style={{
                color: "#121212",
              }}
              spin={isLoading ? true : false}
            />
          </Button>
          <Button
            type={filter === "" ? "primary" : "secondary"}
            shape="round"
            onClick={() => setFilter("")}
          >
            All
          </Button>
          <Button
            type={filter === "active" ? "primary" : "secondary"}
            shape="round"
            onClick={() => setFilter("active")}
          >
            Active
          </Button>
          <Button
            type={filter === "inactive" ? "primary" : "secondary"}
            shape="round"
            onClick={() => setFilter("inactive")}
          >
            Inactive
          </Button>
          <span
            style={{ fontSize: 22 }}
            onClick={() => setSearchInput(!showSearchInput)}
          >
            {showSearchInput ? "✖️" : "🔍"}
          </span>
        </div>
        {showSearchInput ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              background: "rgba(255,255,255)",
              margin: 15,
              padding: 10,
              border: "2px black",
              borderRadius: 5,
              boxShadow: "4px 4px 6px 0px rgba(50, 50, 50, 0.3)",
            }}
          >
            <Input
              placeholder="Search Advise"
              style={{ border: "none" }}
              onChange={(e) => debouncedSearch(e)}
            />
          </div>
        ) : null}
        {/* <div>{adviseList(filter)}</div> */}

        <div style={{ height: 500, overflow: "auto" }}>
          <InfiniteScroll
            initialLoad={true}
            pageStart={0}
            loadMore={() => handleInfiniteOnLoad()}
            hasMore={hasMoreAdvises && !adviseIsLoading}
            loader={
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Spin />
              </div>
            }
            useWindow={false}
          >
            <div>{adviseList(filter)}</div>
          </InfiniteScroll>
        </div>
      </section>
    </div>
  );
};

export default withRouter(Dashboard);
